import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { TextAreaItem } from "../../../components/forms/FormItems";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import { createNewTask, updateNewTask } from "../tasksSlice";
import { useSelector } from "react-redux";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import { useParams } from "react-router-dom";
import {
  BranchEmployeesSelect,
  BranchPatientsSelect,
  UsersSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import { SelectItem } from "../../../components/forms/FormItems";

import AddEntityForm from "../../../components/templates/AddEntityForm";

const AddNewTask = (props) => {
  const { hide, addText, mode, record } = props;
  const dispatch = useDispatch();
  let { branchId } = useParams();
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [formValues, setFormValues] = useState({
    patient_status_id:
      mode === "edit" && record?.patient?.status_id
        ? record.patient.status_id
        : undefined,
    employee_status_id:
      mode === "edit" && record?.employee?.work_period_status
        ? record.employee.work_period_status
        : undefined,
  });

  const createLoading = useSelector(
    (state) => state.pendingActions["tasks/create"]
  );

  const onFinish = async (values) => {
    let task =
      mode === "edit"
        ? {
            ...values,
            id: record.id,
            assigned_to_id: values.assigned_to_id || null,
            employee_id: values.employee_id || null,
            patient_id: values.patient_id || null,
            type_id: values.type_id || null,
          }
        : values;
    const params = {
      branchId: branchId ? branchId : values.branchId,
      task: task,
    };
    const action =
      mode === "new"
        ? await dispatch(createNewTask(params))
        : await dispatch(updateNewTask(params));
    if (!action.error) {
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };
  const branch_id = branchId ? branchId : selectedBranch;

  const onValuesChange = (values, form) => {
    if (
      formValues.employee_status_id !== undefined &&
      formValues.employee_status_id !== values.employee_status_id
    ) {
      form.setFieldValue("employee_id", null);
    }

    if (
      formValues.patient_status_id !== undefined &&
      formValues.patient_status_id !== values.patient_status_id
    ) {
      form.setFieldValue("patient_id", null);
    }
    setFormValues(values);
    if (values.branchId) {
      setSelectedBranch(values.branchId);
    }
  };

  const employeeFilter = {
    $and: [{ $or: [{ status: formValues.employee_status_id }] }],
  };

  const activePatientFilter = {
    $and: [
      {
        $or: [{ status_id: formValues.patient_status_id }],
      },
    ],
  };

  const items = [
    {
      name: "description",
      required: true,
      comp: (
        <TextAreaItem
          rows={4}
          name="description"
          category="tasks"
          required={true}
        />
      ),
    },

    {
      name: "type_id",
      required: true,
      comp: (
        <SettingsDataSelect
          name="type_id"
          required={true}
          category="tasks"
          settingsdataName={"system_tables/tasks_types"}
        />
      ),
    },
    {
      name: "employee_status_id",
      comp: (
        <RadioButtonItem
          name="employee_status_id"
          category="tasks"
          employeeStatuses={true}
          translated={true}
          initialValue={
            mode === "edit" && record?.employee?.work_period_status
              ? record.employee.work_period_status
              : 1
          }
        />
      ),
    },
    {
      name: "employee_id",
      comp: (
        <BranchEmployeesSelect
          name="employee_id"
          category="tasks"
          getEmployee={branch_id !== null}
          extraParams={{
            filter: employeeFilter,
            scopePrefix: `branches/${branch_id}/`,
          }}
          withId={true}
        />
      ),
    },
    {
      name: "patient_status_id",
      comp: (
        <RadioButtonItem
          name="patient_status_id"
          category="tasks"
          patientStatuses={true}
          translated={true}
          initialValue={
            mode === "edit" && record?.patient?.status_id
              ? record.patient.status_id
              : 1
          }
        />
      ),
    },

    {
      name: "patient_id",
      comp: (
        <BranchPatientsSelect
          name="patient_id"
          category="tasks"
          getPatient={branch_id !== null}
          extraParams={{
            scopePrefix: `branches/${branch_id}/`,
            filter: activePatientFilter,
          }}
        />
      ),
    },
    {
      name: "assigned_to_id",
      comp: (
        <UsersSelect
          name="assigned_to_id"
          category="tasks"
          getUser={branch_id !== null}
          extraParams={{
            scopePrefix: `branches/${branch_id}/`,
            filter: {},
          }}
        />
      ),
    },
  ];
  if (mode === "edit") {
    items.push({
      name: "comment",
      comp: <TextAreaItem rows={2} name="comment" category="tasks" />,
    });
    items.push({
      name: "status",
      comp: <SelectItem taskType={true} name="status" category="tasks" />,
    });
  }

  return (
    <AddEntityForm
      formLayout={{
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      }}
      resource="tasks"
      action="editor"
      activeEntity={record}
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onEntityValuesChange={onValuesChange}
      onDecline={onDecline}
      saveLoading={createLoading}
      addText={addText}
      mode={mode}
      style={{
        padding: "0 128px 0px 128px",
        width: "700px",
      }}
    />
  );
};

AddNewTask.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default AddNewTask;
